import type { Drug } from "../../types";

export const orlistatDrug: Drug = {
  id: "orlistat",
  name: "Orlistat 120mg (Xenical®)",
  drugClass: "Pancreatic lipase inhibitor",
  route: "oral",
  defaultFoodTiming:
    "Take immediately before, during, or within 1 hour of each main meal containing fat. Omit if meal is missed or fat-free.",
  formulations: [
    {
      id: "orlistat-120mg-capsule",
      type: "capsule_ir",
      strength: 120,
      strengthUnit: "mg",
      storageNote:
        "Store blisters at ≤25°C, bottles at ≤30°C. Protect from light and moisture.",
      prescribedItemId: "bc9e9b47-b1d5-436e-b12d-d411e3ed4a22",
    },
  ],
};
